/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Harden_Output6Inputs */

const en_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Growth dashboard`)
};

const ar_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة النمو`)
};

const bn_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গ্রোথ ড্যাশবোর্ড`)
};

const de_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachstums-Dashboard`)
};

const es_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de crecimiento`)
};

const fr_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de croissance`)
};

const pt_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de crescimento`)
};

const zh_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增长看板`)
};

const tr_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyüme panosu`)
};

const ru_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дашборд роста`)
};

const pl_svc_programmatic_seo_harden_output6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard wzrostu`)
};

/**
* | output |
* | --- |
* | "Growth dashboard" |
*
* @param {Svc_Programmatic_Seo_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_harden_output6 = /** @type {((inputs?: Svc_Programmatic_Seo_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "de") return de_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "es") return es_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_harden_output6(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_harden_output6(inputs)
	return en_svc_programmatic_seo_harden_output6(inputs)
});
export { svc_programmatic_seo_harden_output6 as "svc_programmatic-seo_HARDEN_output" }